import { create } from "zustand";
import type { Party, QueueSong, PartyMember, UserRole, PartyWrappedStats } from "../types";

interface PartyState {
  currentParty: Party | null;
  userRole: UserRole | null;
  queue: QueueSong[];
  members: PartyMember[];
  currentSong: QueueSong | null;
  activeTab: "queue" | "search" | "favorites" | "settings";
  isTVMode: boolean;
  partyEndedSummary: PartyWrappedStats | null;

  setParty: (party: Party | null) => void;
  setUserRole: (role: UserRole | null) => void;
  setQueue: (queue: QueueSong[]) => void;
  setMembers: (members: PartyMember[]) => void;
  setCurrentSong: (song: QueueSong | null) => void;
  setActiveTab: (tab: "queue" | "search" | "favorites" | "settings") => void;
  setTVMode: (isTVMode: boolean) => void;
  setPartyEndedSummary: (summary: PartyWrappedStats | null) => void;
  resetParty: () => void;
}

export const usePartyStore = create<PartyState>((set) => ({
  currentParty: null,
  userRole: null,
  queue: [],
  members: [],
  currentSong: null,
  activeTab: "queue",
  isTVMode: false,
  partyEndedSummary: null,

  setParty: (currentParty) => set({ currentParty }),
  setUserRole: (userRole) => set({ userRole }),
  setQueue: (queue) => set({ queue }),
  setMembers: (members) => set({ members }),
  setCurrentSong: (currentSong) => set({ currentSong }),
  setActiveTab: (activeTab) => set({ activeTab }),
  setTVMode: (isTVMode) => set({ isTVMode }),
  setPartyEndedSummary: (partyEndedSummary) => set({ partyEndedSummary }),
  resetParty: () =>
    set({
      currentParty: null,
      userRole: null,
      queue: [],
      members: [],
      currentSong: null,
      activeTab: "queue",
      isTVMode: false,
    }),
}));
